import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { initMonitoring } from './lib/monitoring';
import { bootstrapTma } from './lib/tma';
import './styles/index.css';

void initMonitoring('web');
const tma = bootstrapTma();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

try {
  createRoot(rootEl).render(
    <StrictMode>
      <App tma={tma} />
    </StrictMode>,
  );
} catch (err) {
  // Последний рубеж: если не поднялся даже React, на экране должен быть текст, а не пустота.
  rootEl.textContent = `Приложение не запустилось: ${err instanceof Error ? err.message : String(err)}`;
  rootEl.setAttribute('style', 'padding:24px;font:14px system-ui;color:#f3f4f6');
  throw err;
}
